import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { toolsApi, setToolsToken, clearToolsToken, getToolsToken } from "@/lib/toolsApi";

const ToolsAuthContext = createContext(null);

export const useToolsAuth = () => useContext(ToolsAuthContext);

export const ToolsAuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    if (!getToolsToken()) {
      setUser(null);
      setLoading(false);
      return;
    }
    try {
      const { data } = await toolsApi.get("/tools/auth/me");
      setUser(data);
    } catch {
      clearToolsToken();
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = async (email, password) => {
    const { data } = await toolsApi.post("/tools/auth/login", { email, password });
    setToolsToken(data.access_token);
    setUser(data.user);
    return data.user;
  };

  const register = async (email, password, firstName) => {
    const { data } = await toolsApi.post("/tools/auth/register", {
      email,
      password,
      first_name: firstName,
    });
    setToolsToken(data.access_token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    clearToolsToken();
    setUser(null);
  };

  return (
    <ToolsAuthContext.Provider value={{ user, loading, login, register, logout, refresh }}>
      {children}
    </ToolsAuthContext.Provider>
  );
};
